import { Trans } from '@lingui/react/macro';

import Paragraph from '@/design_system/Typography/Paragraph';

export const GenericError = () => {
  return (
    <Paragraph>
      <Trans id="_general.error.please-refresh">
        An error has occurred. Please {/* eslint-disable-next-line */}
        <a
          onClick={() => window.location.reload()}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          refresh the page
        </a>{' '}
        and try again.
      </Trans>
    </Paragraph>
  );
};
